import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { setEmailChangeRequested } from 'src/app/root-store/jobseeker-store/jobseeker-profile/actions';
import { selectIsEmailChangeRequested } from 'src/app/root-store/jobseeker-store/jobseeker-profile/selectors';
import { selectIsJobseekerSettingsLoading, selectIsJobseekerSettingUpdating } from 'src/app/root-store/jobseeker-store/jobseeker-settings/selectors';
import { selectCurrentWebsiteNameForSeo, selectIsPasswordChangeRequired } from 'src/app/root-store/selectors';
import { AppState } from 'src/app/root-store/state';
import { MetaService } from 'src/app/shared/services/meta.service';

@Component({
    selector: 'app-jobseeker-settings',
    templateUrl: './jobseeker-settings.component.html',
    styleUrls: ['./jobseeker-settings.component.scss'],
    standalone: false
})
export class JobseekerSettingsComponent implements OnInit {
 
  metaDataSubscription: Subscription;

  isLoading$: Observable<boolean>;
  isUpdating$: Observable<boolean>;
  isJobseekerPasswordChangeRequired$: Observable<boolean>;

  isJobseekerEmailChangeRequested$: Observable<boolean>;

  constructor(private store: Store<AppState>, private metaService: MetaService) { }

  ngOnInit(): void {
    this.isLoading$ = this.store.pipe(select(selectIsJobseekerSettingsLoading));
    this.isUpdating$ = this.store.pipe(select(selectIsJobseekerSettingUpdating));
    this.isJobseekerPasswordChangeRequired$ = this.store.pipe(select(selectIsPasswordChangeRequired));

    this.isJobseekerEmailChangeRequested$ = this.store.select(selectIsEmailChangeRequested);

    this.metaDataSubscription = this.store.pipe(select(selectCurrentWebsiteNameForSeo)).subscribe(d => {
      this.metaService.updateMetaData(d);
    });
  }

  ngOnDestroy() {
    this.metaDataSubscription.unsubscribe()
    this.store.dispatch(setEmailChangeRequested({ payload: false }));
  }
}
